import { formatDate } from "../../tools/utils";
import { type Demande } from "../../types/Demande";
import type { ServerFile } from "../../types/ServerFile";
import ProfilListItem from "../Common/ProfilListItem";
import ImageIcon  from "../Common/ImageIcon";
import { NavLink } from "react-router";
import ProfilDisplay from "../Common/ProfilDisplay";
import TypeFraisItem from "../Common/TypeFrais";
import FondInfo from "../Common/FondInfo";
import { useTrads } from "../../contexts/trads/useTrads";
import DemandeUploadCreance from "./DemandeUploadCreance";

function DemandeItemComponent({demande,hideuser,editable}:{demande:Demande,hideuser?:boolean,editable?:boolean}){

    const {translate}=useTrads();

    return (

        <>
        <h2>{demande.titre} </h2>
        {!hideuser?<>{translate('demande_par')} 
            {demande.inscription? <ProfilDisplay inscription={demande.inscription} />:
            <ProfilListItem userid={demande.id_inscription} />}

        
        
        <br /></>:null}
        <small>{formatDate(demande.date_creation)}</small>
        
        {(editable && demande.statut!='accepte' && demande.statut!='refuse')?
        <nav>
            <NavLink to={`/demande/${demande.id.toString()}/edit`}>{translate('btn_edit')}</NavLink>
        </nav>
        :null
        }


        <div>
            <dl className="row">
                <dt className="col-sm-3">{translate('demande_statut')}</dt> <dd className="col-sm-9">{translate(demande.statut)}</dd>
                <dt className="col-sm-3">{translate('demande_comment')}</dt> <dd className="col-sm-9"> {demande.comment}</dd>
                <dt className="col-sm-3">{translate('demande_fond')}</dt> <dd className="col-sm-9"> <FondInfo fondId={demande.fond_id} /></dd>

            </dl>
            <div>
                <table className="table ">
                    <thead>
                        <tr><th>{translate('demande_type_frais')}</th><th></th></tr>
                    </thead>
                    <tbody>
                        {Object.keys(demande.frais).map((k)=>(
                                <tr key={k}><th>
                                <TypeFraisItem type_frais_id={k} />
                            </th><td className="text-end">{demande.frais[k]}</td></tr>
                        ))}
                        
                        
                
                    </tbody>
                    <tfoot className="table-group-divider">
                        <tr>
                            <th>{translate('demande_type_frais_total')}</th>
                            <td className="text-end"> {demande.montant}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>                
            <dl className="row">
            
                <dt className="col-sm-3">{translate('demande_justificatifs')}</dt>
            
                <dd className="col-sm-9">
                {demande.justificatifs.length?
                
                
                <ul>
                {demande.justificatifs.map((e:ServerFile) => (
                <li key={e.id}><a  href={e.url}><ImageIcon mimetype={e.mimetype} /> {e.filename}</a></li> 
                ))}
                </ul>
                
                :<p>{translate('demande_aucun_justificatifs')}</p>
                }</dd>
                
                <dt className="col-sm-3">{translate('demande_preuves')}</dt>
                <dd className="col-sm-9">
                    {demande.preuves.length?
                    <ul>
                    {demande.preuves.map((e:ServerFile) => (
                        <li  key={e.id}><a  href={e.url}><ImageIcon mimetype={e.mimetype} /> {e.filename}</a></li>
                    ))}
                    </ul>
                    :<p>{translate('demande_aucun_preuves')}</p>
                    }
                </dd>
            
                <dt className="col-sm-3">{translate('demande_declarations')}</dt>
                <dd className="col-sm-9">
                    {demande.declarations.length?
                
                    <ul>
                    {demande.declarations.map((e:ServerFile) => (
                        <li  key={e.id}><a href={e.url}><ImageIcon mimetype={e.mimetype} /> {e.filename}</a></li>
                    ))}
                    </ul>
                    
                    :<p>{translate('demande_aucun_declarations')}</p>
                    }
                </dd>




            </dl>
            <div className="d-flex justify-content-between"> 
            <a href={`/ws/demande/${demande.id.toString()}/pdf`}><ImageIcon mimetype="application/pdf" />  {translate('btn_pdf')}</a>
            <DemandeUploadCreance demandeParam={demande}></DemandeUploadCreance>
            </div>
        </div>
        </>

    );
}
export default DemandeItemComponent;